/* eslint-disable react/destructuring-assignment */
var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkIcon } from 'uitk-react-icons';
import * as React from 'react';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
import { Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { HeaderMinimalLanguagesToolbar } from './header-minimal-language-toolbar';
import { SharedUIPickerWrapper } from "../../../common/picker/shared-ui-picker-wrapper";
import { PickerTriggerPlacementType } from "@shared-ui/global-navigation-picker";
import { inject } from "mobx-react";
var HeaderMenu = /** @class */function (_super) {
  __extends(HeaderMenu, _super);
  function HeaderMenu(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    return _this;
  }
  HeaderMenu.prototype.toggleMenu = function () {
    var isOpen = this.state.isOpen;
    this.setState({
      isOpen: !isOpen
    });
  };
  HeaderMenu.prototype.render = function () {
    var globalComponentsContext = this.props.globalComponentsContext;
    var isPickerEnabled = globalComponentsContext.header.localeSelectorEnabled;
    return React.createElement(UitkMenu, {
      isOpen: this.state.isOpen,
      onTriggerClick: this.toggleMenu
    }, React.createElement(UitkMenuTrigger, null, React.createElement(UitkTertiaryButton, {
      className: "custom-trigger-class global-navigation-nav-button",
      size: UitkButtonSize.LARGE
    }, React.createElement(UitkIcon, {
      name: "menu",
      title: "menu",
      id: "menu-icon"
    }))), React.createElement(UitkMenuContainer, {
      position: PositionType.LEFT
    }, React.createElement(UitkMenuList, {
      items: this.props.menuItems
    }, React.createElement(Viewport, null, React.createElement(ViewSmall, null, isPickerEnabled ? React.createElement(SharedUIPickerWrapper, {
      pickerTriggerPlacementType: PickerTriggerPlacementType.MENU_ITEM
    }) : React.createElement(HeaderMinimalLanguagesToolbar, {
      languages: this.props.languages
    }))))));
  };
  HeaderMenu = __decorate([inject('globalComponentsContext')], HeaderMenu);
  return HeaderMenu;
}(React.Component);
export { HeaderMenu };